/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import guidebookContentStyle from "../guidebookContentStyle";
import TextContainer from "../../Container/TextContainer";
import Layout from "../../../containers/Layouts/Layout";
import TeaserSlogan from "../../Teaser/TeaserSlogan";
import QuestionsContactSection from "../QuestionsContactSection/QuestionsContactSection";
import DoubleButton from "../../Button/DoubleButton";
import { Helmet } from "react-helmet-async";
import HighlightBox from "../../Box/HighlightBox/HighlightBox";
import backgroundTeaser from "../../../assets/img/guidebook/Teaser_Abfindung-Steuer_700px.jpg";
import Typography from "@mui/material/Typography";
import { Paper } from "@mui/material";
import { gaSet } from "../../../services/googleAnalyticsService";

const GuidebookSettlementTax = () => {
  const title = "Ratgeber - Abfindung und Steuer | Legalbird";

  gaSet({ title: title });

  return (
    <Layout backgroundType={"serviceworld"}>
      <Helmet>
        <title>{title}</title>
        <meta
          name="description"
          content="Sie möchten eine Abfindung erhalten und im Voraus wissen, ob diese steuerpflichtig ist?
        Wir erklären Ihnen die Fünftelregelung."
        />
      </Helmet>

      <Paper sx={guidebookContentStyle.paper}>
        <TeaserSlogan slogan={"Abfindung und Steuer"} backgroundImagePath={backgroundTeaser} height={300} headingColor={"#333333"} />
        <TextContainer>
          <p>
            Sie möchten eine Abfindung erhalten und im Voraus wissen, ob diese steuerpflichtig ist? Sie haben keine Rechtsschutzversicherung und möchten
            erfahren, ob die Anwaltskosten von der Steuer absetzbar sind? Beides erklären wir hier kurz zusammen gefasst.
          </p>
          <hr />
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Ist eine Abfindung steuerpflichtig?
          </Typography>
          <p>
            Eine <strong>Abfindung ist eine Art des Arbeitslohns und somit steuerpflichtig</strong>. Die Abfindung kann allerdings gemäß der sogenannten{" "}
            <strong>“Fünftelregelung”</strong> ermäßigt besteuert werden..
          </p>
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Was ist die Fünftelregelung?
          </Typography>
          <p>
            Nach der Fünftelregelung kann die Abfindung in der Steuererklärung verteilt auf 5 Jahre angegeben werden, wenn sie in Form einer Einmalzahlung zur{" "}
            <strong>“Zusammenballung von Einkünften”</strong> führt. Eine Zusammenballung von Einkünften liegt vor, wenn die Abfindung höher ist als der Arbeitslohn, den
            der Arbeitnehmer bei Fortsetzung des Dienstverhältnisses bis zum Ende des Kalenderjahres noch bezogen hätte. Statt in einem Jahr ein sehr hohes
            Einkommen versteuern zu müssen, wird dann 5 Jahre lang das Einkommen um ein Fünftel der Abfindungssumme erhöht und versteuert. Wichtig zu wissen:
            Wurde bereits im Arbeitsvertrag vereinbart, dass im Fall der Entlassung eine Abfindung gezahlt wird, kann die Abfindung nicht auf 5 Jahre aufgeteilt
            werden. In diesem Fall muss die komplette Summe in einem Jahr angegeben werden.
          </p>
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Sonderfall: Abfindung im öffentlichen Dienst ist steuerfrei
          </Typography>
          <p>
            Für Abfindungen im öffentlichen Dienst sind besondere Steuerbefreiungen zu beachten.{" "}
            <strong>Abfindungen aufgrund der Beamten-(Pensions-)Gesetze sind in vollem Umfang steuerfrei.</strong> Hierzu rechnen z. B. Ausgleichszahlungen oder
            Kapitalabfindungen.
          </p>
          <p>
            Außerdem sind Leistungen aus öffentlichen Mitteln an Arbeitnehmer des Steinkohle- und Erzbergbaus, des Braunkohletiefbaus und der Eisen- und
            Stahlindustrie aus Anlass von Stilllegungs-, Einschränkungs-, Umstellungs- oder Rationalisierungsmaßnahmen in voller Höhe steuerfrei.
          </p>

          <HighlightBox headline={"Wichtiger Tipp: Prozesskosten sind steuerlich absetzbar!"}>
            <p>
              Die Prozesskosten für Ihre Kündigungsschutzklage sind vollständig steuerlich absetzbar! Als Arbeitnehmer gelten Kosten für eine Rechtsverfolgung
              (Beratung-, Vertretungs- und Prozesskosten) als Werbungskosten, die in der Steuerberechnung vom Arbeitslohn abgezogen werden können und somit die
              Steuerbemessungsgrundlage mindern. Sollten Sie also die Kosten für Ihre Kündigungsschutzklage selbst tragen müssen, können Sie zumindest einen
              Teil in Form von geringeren Steuerabgaben zurück erhalten.
            </p>
          </HighlightBox>
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Jetzt professionell gegen Ihre Kündigung vorgehen!
          </Typography>
          <p>
            Sie möchten Ihren Arbeitsplatz zurück oder eine Abfindung erhalten? Starten Sie jetzt ganz einfach mit dem ersten Schritt und lassen Sie Ihre
            Kündigung unverbindlich prüfen. Wir sind auf Arbeitsrecht spezialisiert und kümmern uns persönlich um Sie.
          </p>
          <DoubleButton
            buttonText={"Kündigung unverbindlich prüfen"}
            buttonLink={"/servicewelt"}
            backText={"Zurück zum Ratgeber"}
            backLink={"/ratgeber/arbeitsrecht"}
          />
          <QuestionsContactSection />
        </TextContainer>
      </Paper>
    </Layout>
  );
};

export default GuidebookSettlementTax;
